// @ts-check
import { createDataGridContext } from '~/components/Shared/ZeroDataGrid/ZeroDataGrid.context';
import { useContext } from "react";

const [TemplateDataGridContext, TemplateDataGridContextProvider] = createDataGridContext('templates');
export { TemplateDataGridContext, TemplateDataGridContextProvider };

/** @returns {BaseDataGridContextValue} */
export function useTemplateDataGridContext() {
    return useContext(TemplateDataGridContext);
}
